<cc-lazy-host *ngIf="isModalOpen$ | async" [componentId]="componentId" />
